import Icon from "@/components/Icon"
import SortDirectionHeading from "@/components/SortDirectionHeading"
import { type MarriageClaim, type ObjectSchemaProperty } from "@/models"
import { faEdit } from "@fortawesome/free-solid-svg-icons"
import { css } from "vite-css-in-js"
import { toRaw } from "vue"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import { useEditingSearchState } from "../../state"
import { getDisplayComponent } from "../Helpers"

const tableStyling = css`
	td {
		vertical-align: middle;
	}

	td div {
		display: flex;
	}
`

const SearchMarriageClaimTable: ReactiveComponent = () => {
	const state = useEditingSearchState()

	function renderSortableHeader(column: ObjectSchemaProperty) {
		return (
			<SortDirectionHeading
				key={column.vueKey()}
				direction={state.sort.direction}
				isSelected={toRaw(state.sort.by) === column}
				setDirection={(direction) => state.changeSort({ by: column, direction })}
				style="vertical-align: middle;"
			>
				{column.formatName()}
			</SortDirectionHeading>
		)
	}

	function renderDisplay(claim: MarriageClaim, column: ObjectSchemaProperty) {
		const DisplayComponent = getDisplayComponent(column.usedSchema)
		return <DisplayComponent value={column.getValue(claim)} />
	}

	return () => (
		<table
			class="table small table-striped table-hover mb-0 grid-table grid-table-bordered"
			style={{
				width: "100%",
				tableLayout: "fixed",
				whiteSpace: "nowrap",
				gridTemplateColumns: `max-content repeat(${state.allColumns.length}, auto)`,
			}}
		>
			<thead>
				<tr>
					<th>Actions</th>
					{state.allColumns.map((column) => renderSortableHeader(toRaw(column)))}
				</tr>
			</thead>
			<tbody class={tableStyling}>
				{state.claims.map((claim: MarriageClaim) => (
					<tr key={claim.Id}>
						<td class="d-flex justify-content-center">
							<a
								class="btn btn-primary"
								title="Claim Details"
								href={`/claims/marriageClaims/${claim.Id}`}
								style={{ padding: "0.1rem 0.5rem", width: `3rem` }}
								target="_blank"
							>
								<Icon icon={faEdit} />
							</a>
						</td>
						{state.allColumns.map((column) => (
							<td key={column.vueKey()}>{renderDisplay(claim, column)}</td>
						))}
					</tr>
				))}
			</tbody>
		</table>
	)
}

export default defineComponent(SearchMarriageClaimTable)
